module.exports = __webpack_public_path__ + "img/couples-079.22a23bb7.jpg";